export default "__VITE_ASSET__ZNVLklOw__"